import React, { useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import loaderImg from "../../icons/photos/loaderImg.gif";
import loaderImgGIF from '../../media/images/loaderImgGIF.gif'

import './backdrop.scss'
import { useState } from 'react';
import { RiCameraLensLine, RiHome3Line } from 'react-icons/ri';
import { MdMicNone, MdOutlineVideocam } from 'react-icons/md';
import { isWifiConnection } from './isWifiConnection';

const DummyBackdropLoader = ({
    categoryObj,
}) => {
    const [open, setOpen] = useState(true);
    const [searchLoader, setSearchLoader] = useState(true);
    const [messaage, setMessaage] = useState(`Please be patient while we search for ${categoryObj?.category_display_name_chr ? categoryObj?.category_display_name_chr : ''} professional to assist you.`);

    const wifiStatus = isWifiConnection();

    const handleClose = () => {
        setOpen(false);
    };
    const handleOpen = () => {
        setOpen(true);
    };


    return (
        <div className={`backdrop ${open ? 'open' : ''}`}>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', width: '100vw', height: '100dvh' }}>

                {/* <img className='loader-gif' src={loaderImgGIF} alt='Error Loading' />
                <p className="text-center" style={{ color: 'black', fontSize: '20px', margin: '25px' }}>
                    {messaage}
                </p> */}

                <div
                    className='row mx-0 d-flex flex-column'
                    style={{ minHeight: 'calc(100dvh - 0px)' }}
                >
                    <div className='row mx-0 '>
                        {window.innerWidth > 768 && <div className='col-md-3'></div>}
                        <div
                            className={`col-md-6 d-flex position-relative px-3 py-1`}
                        >
                            <div className='row mx-0'>
                                <div className='col-12 px-0 d-flex justify-content-center align-items-center my-3'>
                                    <span className='fs-4 font-w600 text-center text-black'>{`Searching for a Pro`}</span>
                                </div>

                                <div className='col-12 px-0'>
                                    <img
                                        // className='loader-gif'
                                        style={{ width: '100%' }}
                                        src={loaderImgGIF}
                                        alt='Searching for a Pro'
                                    />
                                </div>

                                <div className='col-12 px-0 d-flex justify-content-center align-items-center mt-2'>
                                    <span className='fs-5 font-w600 text-center '>
                                        {messaage}
                                    </span>
                                </div>

                                <div className='col-12 d-flex flex-column mt-2 p-3 bg-white rounded-2'>
                                    <div className='w-100'>
                                        <span className='fs-4 font-w600  text-black'>
                                            {`Prepare for your Chilll request`}
                                        </span>
                                    </div>



                                    <div className='w-100 mt-2 d-flex align-items-baseline'>
                                        <span className='me-3' style={{ color: '', fontSize: '20px' }}>
                                            <RiCameraLensLine />
                                        </span>
                                        <span className='fs-4 font-w500'>
                                            {`Clean your camera lens`}
                                        </span>
                                    </div>

                                    <div className='w-100 mt-2 d-flex align-items-baseline'>
                                        <span className='me-3' style={{ color: '', fontSize: '20px' }}>
                                            <RiHome3Line />
                                        </span>
                                        <span className='fs-4 font-w500 '>
                                            {`Organize the area for easy access`}
                                        </span>
                                    </div>

                                    <div className='w-100 my-2' style={{ height: '1px', background: '#0000007d' }}></div>

                                    <div className='w-100 mt-2 d-flex align-items-baseline'>
                                        <span className='me-3' style={{ color: wifiStatus ? '#21d262' : '#ff0000', fontSize: '20px' }}>
                                            <i class="bi bi-wifi"></i>
                                        </span>
                                        <span className='fs-4 font-w600'>
                                            {`${wifiStatus ? 'Connected' : 'Connect'} to wi-fi`}
                                        </span>
                                    </div>

                                    <div className='w-100 d-flex align-items-baseline'>
                                        <span className='me-3' style={{ color: '#21d262', fontSize: '20px' }}>
                                            <MdMicNone />
                                        </span>
                                        <span className='fs-4 font-w600 ' style={{ color: '#879ebf' }}>
                                            {`Microphone access allowed`}
                                        </span>
                                    </div>

                                    <div className='w-100 mt-2 d-flex align-items-baseline'>
                                        <span className='me-3' style={{ color: '#21d262', fontSize: '20px' }}>
                                            <MdOutlineVideocam />
                                        </span>
                                        <span className='fs-4 font-w600' style={{ color: '#879ebf' }}>
                                            {`Camera access allowed`}
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    )
}

export default DummyBackdropLoader;